@if(data()){
  @switch (data().data.level) {
    @case (1) {
      <h1 class="py-2">{{ data().data.text }} </h1>
    }
    @case (2) {
      <h2 class="py-2">{{ data().data.text }} </h2>
    }
    @case (3) {
      <h3 class="py-2">{{ data().data.text }} </h3>
    }
    @case (4) {
      <h4 class="py-2">{{ data().data.text }} </h4>
    }
  }
}
